import { AsyncPipe } from '@angular/common';
import { Component, inject, Input, OnInit } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Store } from '@ngrx/store';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { SharedModule } from 'primeng/api';
import { SelectModule } from 'primeng/select';
import { Observable, tap } from 'rxjs';

import { CommonMidCountry } from '@offconon/core-api';

import { SharedUiFormElementsCountrySelectListModule } from '../../shared-ui-form-elements-country-select-list.module';
import { fetchCountryList } from '../../store/country.actions';
import { selectCountryList } from '../../store/country.selectors';
@Component({
  selector: 'offconon-all-country-dropdown-list',
  templateUrl: './all-country-dropdown-list.component.html',
  styleUrls: ['./all-country-dropdown-list.component.scss'],
  imports: [
    SelectModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    AsyncPipe,
    TranslateModule,
    SharedUiFormElementsCountrySelectListModule,
  ],
})
export class AllCountryDropdownListComponent implements OnInit {
  @Input({ required: true }) countryFormControl: FormControl;
  @Input() selectBrowserCountry = false;
  @Input() selectFirst = true;
  @Input() disabled = false;
  private store$ = inject(Store);
  private translateService = inject(TranslateService);

  countryList$: Observable<CommonMidCountry[]>;
  filteredCountries: any[] = [];

  ngOnInit(): void {
    this.store$.dispatch(fetchCountryList());
    this.countryList$ = this.store$.select(selectCountryList).pipe(
      tap((countryList) => {
        this.filteredCountries = countryList.map((element) => {
          const name = element.name ? this.translateService.instant(element.name) : '';
          return {
            id: element.id,
            iso_code: element.iso_code,
            name: name,
            province_count: element.province_count,
          };
        });

        if (this.selectBrowserCountry) {
          const countryCode = navigator.language.split('-')[1];
          const country = countryList.find((c) => c.iso_code === countryCode);
          if (country) {
            this.countryFormControl.patchValue(country.id);
          }
        }
        if (this.selectFirst && !this.countryFormControl?.value) {
          this.countryFormControl.patchValue(countryList?.[0]?.id);
        }
      }),
    );
  }
  filterCountries(event: any) {
    const query = event.filter.toLowerCase();
    this.filteredCountries = this.filteredCountries.filter((country) => {
      country.name.toLowerCase().includes(query);
      return country;
    });
  }
}
